module.exports = __webpack_public_path__ + "static/img/18036D_2_3_R_20191227_LC.3775d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18036D_2_3_R_20191227_LC.png
// module id = zd3i
// module chunks = 0